import React, {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import AnalyticsMenu from 'navigation/sub-routes/Analytics/AnalyticsMenu'
import {getAllMailInbox} from 'actions/inbox'
import {getKnowledgebase} from 'actions'

const AnalyticsLayout = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllMailInbox())
    dispatch(getKnowledgebase())
  }, [dispatch])

  return (
    <>
      <AnalyticsMenu />
      <div className="vmoSideBar-wrap" style={{background: 'var(--bg-color)'}}>
        <Outlet />
      </div>
    </>
  )
}

export default AnalyticsLayout
